var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTabOne(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bulk/box"
  }, /*#__PURE__*/React.createElement("g", {
    id: "box"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.4,
    d: "M20.0999 7.43998C20.0999 7.97998 19.8099 8.46995 19.3499 8.71995L17.6099 9.65995L16.1299 10.45L13.0599 12.11C12.7299 12.29 12.3699 12.38 11.9999 12.38C11.6299 12.38 11.2699 12.29 10.9399 12.11L4.6499 8.71995C4.1899 8.46995 3.8999 7.97998 3.8999 7.43998C3.8999 6.89998 4.1899 6.40995 4.6499 6.15995L6.6199 5.09996L8.18991 4.24998L10.9399 2.77C11.5999 2.41 12.3999 2.41 13.0599 2.77L19.3499 6.15995C19.8099 6.40995 20.0999 6.89998 20.0999 7.43998Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    opacity: 0.4,
    d: "M9.90021 13.2904L4.0502 10.3604C3.6002 10.1304 3.08021 10.1604 2.65021 10.4204C2.22021 10.6804 1.97021 11.1404 1.97021 11.6404V17.1704C1.97021 18.1304 2.5002 18.9904 3.3602 19.4204L9.21021 22.3404C9.4102 22.4404 9.63022 22.4904 9.85022 22.4904C10.1102 22.4904 10.3702 22.4204 10.6002 22.2704C11.0302 22.0104 11.2802 21.5504 11.2802 21.0504V15.5204C11.2902 14.5804 10.7602 13.7204 9.90021 13.2904Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    opacity: 0.4,
    d: "M22.03 11.6497V17.1796C22.03 18.1296 21.5 18.9896 20.64 19.4196L14.79 22.3496C14.59 22.4496 14.37 22.4996 14.15 22.4996C13.89 22.4996 13.63 22.4297 13.39 22.2797C12.97 22.0197 12.71 21.5596 12.71 21.0596V15.5396C12.71 14.5796 13.24 13.7196 14.1 13.2896L16.25 12.2196L17.75 11.4696L19.95 10.3696C20.4 10.1396 20.92 10.1596 21.35 10.4296C21.77 10.6896 22.03 11.1497 22.03 11.6497Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M17.6101 9.65997L16.1301 10.45L6.62012 5.09998L8.19012 4.25L17.3701 9.42999C17.4701 9.48999 17.5501 9.56997 17.6101 9.65997Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M17.75 11.4707V13.7407C17.75 14.1507 17.41 14.4907 17 14.4907C16.59 14.4907 16.25 14.1507 16.25 13.7407V12.2207L17.75 11.4707Z",
    fill: "#1C1C1C"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabOne);
export default __webpack_public_path__ + "static/media/tabOne.efd56e6ee7b74d343a81086845716c17.svg";
export { ForwardRef as ReactComponent };